import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getUserCustomClaims } from '../Services/getUserClaims';

export default function ProtectedRoute({ children, requiredClaims }) {
  const [checking, setChecking] = React.useState(true);
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [claimsOk, setClaimsOk] = React.useState(true);

  React.useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      const authed = !!user;
      setIsAuthenticated(authed);
      if (authed && requiredClaims) {
        const claims = await getUserCustomClaims();
        const ok = Object.entries(requiredClaims).every(([k, v]) => claims[k] === v);
        setClaimsOk(ok);
      } else {
        setClaimsOk(true);
      }
      setChecking(false);
    });
    return () => unsubscribe();
  }, [requiredClaims]);

  if (checking) return null;
  if (!isAuthenticated) return <Navigate to='/' replace />;
  if (!claimsOk) return <Navigate to='/' replace />;
  return children;
}


